
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/setting/info/terms/[file]",
      function () {
        return require("private-next-pages/setting/info/terms/[file].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/setting/info/terms/[file]"])
      });
    }
  